"use strict";

require("core-js/modules/es6.object.assign");

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: inline-block;\n    position: relative;\n    width: 64px;\n    height: 64px;\n\n    & > div {\n      transform-origin: 32px 32px;\n      animation: spinner 1.2s linear infinite;\n    }\n    & > div:after {\n      content: \" \";\n      display: block;\n      position: absolute;\n      top: 3px;\n      left: 29px;\n      width: 5px;\n      height: 14px;\n      border-radius: 20%;\n      ", ";\n    }\n    & > div:nth-child(1) {\n      transform: rotate(0deg);\n      animation-delay: -1.1s;\n    }\n    & > div:nth-child(2) {\n      transform: rotate(30deg);\n      animation-delay: -1s;\n    }\n    & > div:nth-child(3) {\n      transform: rotate(60deg);\n      animation-delay: -0.9s;\n    }\n    & > div:nth-child(4) {\n      transform: rotate(90deg);\n      animation-delay: -0.8s;\n    }\n    & > div:nth-child(5) {\n      transform: rotate(120deg);\n      animation-delay: -0.7s;\n    }\n    & > div:nth-child(6) {\n      transform: rotate(150deg);\n      animation-delay: -0.6s;\n    }\n    & > div:nth-child(7) {\n      transform: rotate(180deg);\n      animation-delay: -0.5s;\n    }\n    & > div:nth-child(8) {\n      transform: rotate(210deg);\n      animation-delay: -0.4s;\n    }\n    & > div:nth-child(9) {\n      transform: rotate(240deg);\n      animation-delay: -0.3s;\n    }\n    & > div:nth-child(10) {\n      transform: rotate(270deg);\n      animation-delay: -0.2s;\n    }\n    & > div:nth-child(11) {\n      transform: rotate(300deg);\n      animation-delay: -0.1s;\n    }\n    & > div:nth-child(12) {\n      transform: rotate(330deg);\n      animation-delay: 0s;\n    }\n    @keyframes spinner {\n      0% {\n        opacity: 1;\n      }\n      100% {\n        opacity: 0;\n      }\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var Spinner = styled_components_1["default"].div(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return styled_components_1.css(_templateObject2(), theme.palette.primary.background);
});
/**
 * Loader component
 */

var Loader = function Loader(_a) {
  var rest = __rest(_a, []);

  return react_1["default"].createElement(Spinner, Object.assign({}, rest), react_1["default"].createElement("div", null), react_1["default"].createElement("div", null), react_1["default"].createElement("div", null), react_1["default"].createElement("div", null), react_1["default"].createElement("div", null), react_1["default"].createElement("div", null), react_1["default"].createElement("div", null), react_1["default"].createElement("div", null), react_1["default"].createElement("div", null), react_1["default"].createElement("div", null), react_1["default"].createElement("div", null), react_1["default"].createElement("div", null));
};

exports["default"] = Loader;